<template>
    <ui-modal :title="title" name="sales-reservations-queue" icon="far fa-clock" size="lg">
        <div class="modal-content-line">
            <ui-table
                name="reservationsList"
                tr-component="sales/reservations/queue-table-line"
                not-found-icon="fal fa-user"
                not-found-text="Não foi possível encontrar nenhuma Reserva"
                :data="data"
                :per-page="25"
                :columns="tableColumns"
                :loading="loading"
            />
        </div>
    </ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'
	import { uiTable } from '@/components/ui'
	import { reserveQueue } from '@/services/axios'

	export default {
		name:'queue-modal',
		components: {
			uiModal,
			uiTable,
		},

		data() {
			return {
				deal: null,
				title: '',
				loading: false,
				data: [],

				tableColumns: [
					{
						title: '#',
					},
					{
						title: 'Código',
					},
					{
						title: 'Data Solicitação',
					},
					{
						title: 'Solicitante',
					},
					{
						title: 'Cliente',
					},
					{
						title: 'Expira em:',
					},
					{
						title: 'Status',
					},
					{
						title: '',
					},
				],
			}
		},

		mounted() {
			this.$root.$on('modal-open-sales-reservations-queue', (params) => {
				this.deal = params
				this.getData()
			})

			this.$root.$on('modal-sales-reservations-reload', () => {
				this.getData()
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-sales-reservations-queue')
		},

		methods: {
			getData(){
				this.loading = true
				reserveQueue
					.getData(this.deal.deal)
					.then((res) => {
						if (res.status === 200) {
							this.data = res.data

							this.title =
								'Fila de reservas: ' + this.data[0].name + ' - ' + this.data[0].block + '/' + this.data[0].number
						} else {
							this.$toastr.s(res.data.msg)
						}
					})
					.catch((error) => {
                        if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
					})
					.finally(() => {
						// Conclui os loads
						this.loading = false
					})
			}
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
